import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import profileImage from "../../../../../../../media/images/profileImage.png";
import CarTagView from "../../../../../../components/CarTag";
import BigCompanyIcon from "../../../../../../../media/images/icons/company-big-icon";
import CalendarCheck from "../../../../../../../media/images/icons/calendar-check";
import CallSVG from "../../../../../../../media/images/icons/arrow-steps-register";
import CallOutlineSVG from "../../../../../../../media/images/icons/call-outline";
import { Link } from "react-router-dom";

export default function InfoContent() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "3px",
          }}
        >
          <img
            width={30}
            height={30}
            style={{
              borderRadius: "50%",
            }}
            src={profileImage}
            alt=""
          />
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            رضا یعقوبی‌فریان پور
          </Typography>
        </Box>
        <CarTagView />
      </Box>
      <Box
        sx={{
          mt: 1,
          borderRadius: "8px",
          backgroundColor: "info.light",
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          padding: "6px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <BigCompanyIcon size={16} color={theme.palette.primary.main} />
          <Typography
            sx={{
              color: "primary.main",
              fontSize: "10px",
              fontWeight: "600",
            }}
          >
            شرکت حمل و نقل:
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "12px",
          }}
        >
          نام شرکت در این قسمت طولانی
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 1,
          backgroundColor: "primary.light",
          padding: "4px",
          borderRadius: "6px",
        }}
      >
        <Typography
          sx={{
            fontFamily: "IrSans",
            textAlign: "center",
            color: "primary.main",
          }}
        >
          شماره مجوز: 55555
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 1,
          borderRadius: "8px",
          backgroundColor: "info.light",
          display: "flex",
          justifyContent: "space-between",
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          padding: "6px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <CalendarCheck size={16} color={theme.palette.textColor.main} />
          <Typography
            sx={{
              fontSize: "10px",
              fontWeight: "600",
            }}
          >
            تاریخ دریافت مجوز:{" "}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "12px",
            fontFamily: "IrSans",
          }}
        >
          1402/12/05 13:20
        </Typography>
      </Box>

      <Box
        sx={{
          mt: 1,
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          borderRadius: "8px",
          backgroundColor: "info.light",
          padding: "6px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <CallOutlineSVG size={12} color={theme.palette.primary.main} />
          <Typography
            sx={{
              fontSize: "10px",
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            اطلاعات تماس مبدا:
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            noWrap
            sx={{
              fontSize: "12px",
              fontWeight: "600",
              fontFamily: "IrSans",
            }}
          >
            9155555555 کریمی‌پوریان
          </Typography>
          <Link
            to={"tel:9155555555"}
            style={{
              display: "flex",
              gap: "3px",
              borderColor: theme.palette.primary.main,
              borderRadius: "6px",
              borderWidth: "1px",
              borderStyle: "solid",
              alignItems: "center",
              backgroundColor: theme.palette.background.default,
              padding: "4px",
            }}
          >
            <CallOutlineSVG size={12} color={theme.palette.primary.main} />
            <Typography
              sx={{
                fontSize: "12px",
                color: "primary.main",
              }}
            >
              تماس با مبدا{" "}
            </Typography>
          </Link>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          borderRadius: "8px",
          backgroundColor: "info.light",
          padding: "6px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <CallOutlineSVG size={12} color={theme.palette.success.main} />
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: "600",
              color: "success.main",
            }}
          >
            اطلاعات تماس مبدا:
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            noWrap
            sx={{
              fontSize: "12px",
              fontWeight: "600",
              fontFamily: "IrSans",
            }}
          >
            9155555555 کریمی‌پوریان
          </Typography>
          <Link
            to={"tel:9155555555"}
            style={{
              display: "flex",
              gap: "3px",
              borderColor: theme.palette.success.main,
              borderRadius: "6px",
              borderWidth: "1px",
              borderStyle: "solid",
              alignItems: "center",
              backgroundColor: theme.palette.background.default,
              padding: "4px",
            }}
          >
            <CallOutlineSVG size={12} color={theme.palette.success.main} />
            <Typography
              sx={{
                fontSize: "12px",
                color: "success.main",
              }}
            >
              تماس با مقصد{" "}
            </Typography>
          </Link>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          borderRadius: "8px",
          backgroundColor: "info.light",
          padding: "6px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Typography
          variant="body3"
          sx={{
            color: "secondary.main",
          }}
        >
          {" "}
          محل بارگیری:
        </Typography>
        <Typography variant="body3">
          انبار ایران خودرو -جاده قدیم کرج انبار ایران خودرو -جاده قدیم کرج
          انبار ایران خودرو -جاده قدیم کرج
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 1,
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          borderRadius: "8px",
          backgroundColor: "info.light",
          padding: "6px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Typography
          variant="body3"
          sx={{
            color: "secondary.main",
          }}
        >
          {" "}
          توضیحات بار:{" "}
        </Typography>
        <Typography variant="body3">
          انبار ایران خودرو -جاده قدیم کرج انبار ایران خودرو -جاده قدیم کرج
          انبار ایران خودرو -جاده قدیم کرج
        </Typography>
      </Box>
    </Box>
  );
}
